import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { MEDIA } from "@/lib/media";

export default function AdminLogin() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  useEffect(() => { if (!loading && user) navigate("/admin", { replace: true }); }, [user, loading, navigate]);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] px-6 grain">
      <div className="gw-card p-12 max-w-md w-full text-center relative">
        <img src={MEDIA.logo} alt="Golden Wolf" className="w-24 h-24 object-contain mx-auto" />
        <div className="overline mt-6">Staff Portal</div>
        <h1 className="font-heading text-3xl font-bold text-[#FDFBF7] mt-2">Admin Dashboard</h1>
        <p className="text-[#8A877B] text-sm mt-3">Authorized personnel only. Sign in with your Google account.</p>
        <button onClick={login} data-testid="google-login-btn" className="btn-gold w-full mt-8 flex items-center justify-center gap-2 py-3.5">
          <ShieldCheck className="w-5 h-5" /> Sign in with Google
        </button>
      </div>
    </div>
  );
}
